import { Container, StatusDiv } from "./StatusTooltipStyles";

function StatusTooltip(props) {
  const { statusList, className } = props;

  return (
    <Container className={className}>
      {statusList.map((status, index) => {
        return (
          <StatusDiv
            key={index}
            status={status.category}
            onClick={status.callback ? status.callback : () => {}}
            clickable={!!status.callback}
          >
            <p>{status.label.toUpperCase()}</p>
          </StatusDiv>
        );
      })}
    </Container>
  );
}

export default StatusTooltip;
